<template>
  <div class="app-body" ref="body">
    <div class="app-header">
      <router-link class="back" to="/">
        <van-icon name="arrow-left" />
        返回
      </router-link>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="margin-top:3rem;">
      <van-list
        v-model="isLoading"
        :finished="finished"
        :finished-text="finishedtext"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
        class="list"
      >
        <van-cell-group class="items">
          <van-cell v-for="item in list" :key="item.id" class="list-item" @click="toDetail(item)">
            <div class="list-infos">
              <van-image
                fit="cover"
                lazy-load
                :src="rootPath + item.pic"
              />
              <div class="list-detail">
                <div class="list-title">{{ item.title }}</div>
                <div class="list-contents">{{ item.summary ? item.summary : formtText(item.content) }}</div>
                <!-- <div class="list-dates">{{ formatDate(item.createtime) }}</div> -->
              </div>
            </div>
          </van-cell>
          <van-cell v-if="!list || !list.length" class="list-item">
            <div class="list-infos">
              <div class="list-detail">
                <div class="list-title">还没有内容~</div>
              </div>
            </div>
          </van-cell>
        </van-cell-group>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import AppFooter from '../app-footer.vue';
export default {
  components: {
    AppFooter
  },
  mixins: [tools],
  props: {
    id: String
  },
  data() {
    return {
      isLoading: false,
      finished: false,
      count: 0,
      page: 1,
      list: [],
      error: false,
      w: 0,
    }
  },
  computed: {
    ...mapGetters([]),
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.8) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {}
      if (this.w) {
        style = {height: (this.w * 0.88 * 0.333) + 'px'};
      }
      return style;
    }
  },
  watch: {
    id() {
      this.loadData();
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
  },
  activated() {
    if (!this.list || !this.list.length) {
      // this.loadData();
    }
    if (!this.w) {
      this.getImgW();
    }
  },
  methods: {
    loadData(callback) {
      if (!this.id) {
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'vue/home/list',
        data: {pageCurrent: this.page, cateid: this.id},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.list = json.list;
            this.page = json.pageNumber;
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    initData(list) {
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
    onRefresh() {
      this.isLoading = false;
      this.page = 1;
      this.loadData((json) => {
        this.list = json.list;
        this.page = json.pageNumber;

        this.$toast('刷新成功');
      });
    },
    onLoad() {
      // console.log('load.....')
      this.isLoading = false;
      this.finished = false;
      this.page = this.list.length ? this.page + 1 : 1;
      this.loadData((json) => {
        this.list = this.list.concat(json.list);
        this.page = json.pageNumber;

        // 如果已加载完
        if (!json.totalRow || json.totalPage <= json.pageNumber) {
          this.finished = true;
        }
      });
    },
    toDetail(item) {
      this.$router.push('/detail/'+ item.id);
    },
    formtText(content) {
      if (!content) {
        return '';
      }
      let _content = content.replace(/<[^>]+>/g, '').trim();
      return _content;
    }
  }
}
</script>

<style lang="less" scoped>
.app-body{
  min-height:100vh;
  background-color:#fff;
  /deep/ .van-list__finished-text {
    display:none;
  }
}
.app-header {
  position:fixed;
  top:0;
  z-index:99;
  height:3rem;
  width:100%;
  padding:.5rem .6rem .5rem 0;
  box-sizing:border-box;
  .flex-center();
  justify-content:space-between;
  .fixedapp();
  background-color:#f5f5f5;
  .shadow_black(0 1px 1px);
  .back {
    .flex-center-v();
    font-size:1rem;
    .van-icon {
      font-size:1.6rem;
    }
  }
}
.list {
  min-height:calc(100vh - 46px - 50px);
  .items {
    padding:1.5rem 1rem;
    box-sizing:border-box;
    &.van-hairline--top-bottom::after, &.van-hairline-unset--top-bottom::after {
      border-width:0 0;
    }
    &.van-cell-group {
      background-color:#fff;
    }
  }
  &-item {
    margin-bottom:1.5rem;
    background-color:#f6f6f6;
    position:relative;
    // margin-bottom:1rem;
    // padding-top:.5rem;
    // padding-bottom:.5rem;
    .shadow_black(0 0 1px 0, .06);
    border-radius:1rem;
    .van-cell:not(:last-child)::after{
      left:0;
    }
    .van-cell__value--alone {
      box-sizing:border-box;
    }
    .van-hairline--top-bottom::after{
      border-width:0;
    }
    /deep/ .van-image__error, .van-image__loading {
      background-color:#f0f0f0;
    }
    &:first-child {
      // margin-top:0;
    }
  }
  &-infos {
    .flex();
    .van-image {
      flex-shrink:0;
      width:80px;
      height:80px;
    }
  }
  &-detail {
    padding-left:1.2rem;
  }
  &-title {
    .fontsize(1.2rem);
    color:@bluecolor;
  }
  &-contents {
    margin-top:.25rem;
    .fontsize();
    line-height:1.34;
    color:#777;
    overflow:hidden; word-break:break-all; text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:3;
    white-space:pre-wrap;
  }
  &-dates {
    .fontsize();
    text-align:right;
  }
}
</style>